import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
} from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-toggle-map',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent,IconComponent,TranslocoDirective],
  template: `
    <ui-button
      classes="w-full"
      button
      buttonType="default"
      buttonSize="default"
      [loading]="false"
      [disabled]="disabled()"
      [class]="'bg-white border border-gray-300 rounded-[2px] px-3 hover:transparent hover:bg-gray-100'"
      (buttonClick)="changeView()"
      *transloco="let t"
    >
      @if (isMap()) {
        <ui-icon icon="unordered-list" />
        {{ t('LIST') }}
      } @else {
        <ui-icon icon="aim" />
        {{ t('MAP') }}
      }
    </ui-button>
  `,
})
export class ToggleMapComponent {
  protected readonly SHOW_MAP = false;
  isMap = signal<boolean>(this.SHOW_MAP);
  activeMap = output<boolean>()
  disabled = input<boolean>(false);

  changeView() {
    this.isMap.set(!this.isMap())
    this.activeMap.emit(this.isMap())
  }
}
